'use client'

import { can, canAll, canAny, type Permission } from '@shared/permissions'
import { useOptionalAuth } from '@/context/AuthContext'

/** Returns true if the current user has the given permission (or ADMIN_FULL). */
export function usePermission(permission: Permission): boolean {
  const auth = useOptionalAuth()
  const perms = auth?.user?.permissions ?? []
  return can(perms, permission)
}

/** Returns true if the current user has ALL of the given permissions. */
export function usePermissionAll(...permissions: Permission[]): boolean {
  const auth = useOptionalAuth()
  const perms = auth?.user?.permissions ?? []
  return canAll(perms, ...permissions)
}

/** Returns true if the current user has ANY of the given permissions. */
export function usePermissionAny(...permissions: Permission[]): boolean {
  const auth = useOptionalAuth()
  const perms = auth?.user?.permissions ?? []
  return canAny(perms, ...permissions)
}

/** Returns the raw permissions array from the auth context. */
export function usePermissions(): string[] {
  const auth = useOptionalAuth()
  return auth?.user?.permissions ?? []
}
